import { matchPath, useLocation } from "react-router-dom";

/**
 * Whether the current location is under one of a menu entry's paths.
 * `NavLink` only knows its `to`: the home entry links to "/" but also
 * covers /calendar/:id and /tasks/:id, so an entry lists every pattern
 * it stands for. "/" alone matches only the root; every other pattern
 * matches itself and what is under it, as `NavLink` does.
 */
export const isRouteActive = (
	path: string | string[] | undefined,
	pathname: string
): boolean => {
	if (!path) return false;
	return (Array.isArray(path) ? path : [path]).some(
		(pattern) =>
			!!matchPath({ path: pattern, end: pattern === "/" }, pathname)
	);
};

export const useIsRouteActive = (path: string | string[] | undefined) => {
	const { pathname } = useLocation();
	return isRouteActive(path, pathname);
};
